export default __webpack_public_path__ + "static/media/giftbox_animation1.57b9cd14.gif";